module.exports = __webpack_public_path__ + "img/12-1.2e5521c0.png";